import type { ReactElement } from "react";

// material-ui
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

// project imports
import LogoSection from "components/logo";
import AuthCard from "./AuthCard";
import AuthFooter from "./AuthFooter";

// assets
import AuthBackground from "./AuthBackground";

interface Props {
  readonly children: ReactElement;
}

// ==============================|| AUTHENTICATION - WRAPPER ||============================== //

export default function AuthWrapper({ children }: Props) {
  return (
    <Box sx={{ minHeight: "100vh" }}>
      <AuthBackground />
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        sx={{ minHeight: "100vh" }}
      >
        <Grid sx={{ px: 3, mt: 3 }} size={12}>
          <LogoSection />
        </Grid>
        <Grid size={12}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{
              minHeight: {
                xs: "calc(100vh - 210px)",
                sm: "calc(100vh - 134px)",
                md: "calc(100vh - 132px)",
              },
            }}
          >
            <Grid>
              <AuthCard>{children}</AuthCard>
            </Grid>
          </Grid>
        </Grid>
        <Grid sx={{ p: 3 }} size={12}>
          <AuthFooter />
        </Grid>
      </Grid>
    </Box>
  );
}
